angular
  .module('contabilidad.polizas')
  .service('noDeduciblesService', Service)

Service.$inject = ['$api', '$filter', '$schema']

function Service ($api, $filter, $schema) {
  var noDeduciblesService = this

  noDeduciblesService.obtenerInformacionGastosNoDeducibles = obtenerInformacionGastosNoDeducibles
  noDeduciblesService.codificar = codificar

  function obtenerInformacionGastosNoDeducibles (fecha_inicio, fecha_fin, ID_Cliente, ID_Moneda, CuentaBancaria) {
    return $api.get('/kendu/contabilidad/polizas/polizaGatosNoDeducibles', {
      fecha_inicio: fecha_inicio.toYMD(),
      fecha_fin: fecha_fin.toYMD(),
      CuentaBancaria: CuentaBancaria,
    }).then(function (data) {
      return data.map(function (item) {

        return $schema(item, {
          SubTotal: 'number',
          Importe: 'number',
          Importe_Pesos: 'number',
        })

      })
    })
  }

  var verificarCadena = $filter('rPad')

  function codificar (data, inicio) {
    var inicio_poliza = inicio
    var cadenaPrincipal = ''
    var cadA = 'P  AAAAMMDD    &      JJJJ 1 0          ' +
      'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n',

      fechaA,
      fechaB

    try {
      data.forEach(function (item, indice) {

        fechaA = $filter('date')(item.Fecha_Movimiento, 'yyyyMMdd')
        fechaB = verificarCadena($filter('date')(item.Fecha_Movimiento, 'dd/MM/yyyy'), 15)

        if (item.Banco_Forma_Pago === '01') {
          // if(indice===0)
          // {
          cadenaPrincipal += cadA
            .replace('&', '2')
            .replace('AAAAMMDD', fechaA)
            .replace('JJJJ', ('0000' + inicio_poliza).slice(-4))
            .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('GASTOS DIVERSOS DE VENTA', 60))
          // }

          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena('6020810100000000', 16))
            .replace('ZZZZZZZZZZZZZZZ', fechaB)
            .replace('*', 0)
            .replace('YYYYYYYYY', verificarCadena(item.Total.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena('GASTOS DIVERSOS DE VENTA', 43))

          item.cuentas.forEach(function (ele) {

            if (ele.Cuenta_Contable_Deudor !== '') {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable_Deudor.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena(ele.Importe_Pesos.toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))
            }

            if (ele.Cuenta_Contable_Deudor === '' && ele.Tipo_Moneda === '1') {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena(ele.Importe_Pesos.toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))
            }

            if (ele.Cuenta_Contable_Deudor === '' && ele.Tipo_Moneda === '2') {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena(ele.Importe.toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))

              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena((ele.Importe_Pesos - ele.Importe).toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))

            }

          })

          inicio_poliza++
        }
      })

      inicio_poliza = inicio

      data.forEach(function (item, indice) {

        if (item.Banco_Forma_Pago === '02') {
          fechaA = $filter('date')(item.Fecha_Movimiento, 'yyyyMMdd')
          fechaB = verificarCadena('CH-' + item.Referencia, 15)
          // if(indice===0)
          // {
          cadenaPrincipal += cadA
            .replace('&', '2')
            .replace('AAAAMMDD', fechaA)
            .replace('JJJJ', ('0000' + inicio_poliza).slice(-4))
            .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('GASTOS DIVERSOS DE VENTA', 60))
          // }

          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena('6020810100000000', 16))
            .replace('ZZZZZZZZZZZZZZZ', fechaB)
            .replace('*', 0)
            .replace('YYYYYYYYY', verificarCadena(item.Total.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena('GASTOS DIVERSOS DE VENTA', 43))

          item.cuentas.forEach(function (ele) {

            if (ele.Cuenta_Contable_Deudor !== '') {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable_Deudor.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena(ele.Importe_Pesos.toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))
            }

            if (ele.Cuenta_Contable_Deudor === '' && ele.Tipo_Moneda === '1') {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena(ele.Importe_Pesos.toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))
            }

            if (ele.Cuenta_Contable_Deudor === '' && ele.Tipo_Moneda === '2') {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena(ele.Importe.toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))

              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(ele.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', 1)
                .replace('YYYYYYYYY', verificarCadena((ele.Importe_Pesos - ele.Importe).toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(ele.Notas, 43))

            }

          })

          inicio_poliza++
        }
      })

      return cadenaPrincipal
    } catch (err) { // try
      return 'Error'
    }
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/noDeduciblesService.js